var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16309 5.40039C3.16309 2.81156 5.26175 0.712891 7.85059 0.712891H8.14941C10.7382 0.712891 12.8369 2.81156 12.8369 5.40039V5.69922C12.8369 6.81814 12.4453 7.84459 11.7914 8.65049C11.2314 9.34067 10.7091 10.2058 10.7091 11.199V12.4003C10.7091 12.5613 10.5785 12.6919 10.4174 12.6919H5.5826C5.42152 12.6919 5.29093 12.5613 5.29093 12.4003V11.199C5.29093 10.2058 4.76861 9.34067 4.20858 8.65049C3.55466 7.84459 3.16309 6.81814 3.16309 5.69922V5.40039Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66699 13.9629H10.3337",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 15.2402H9.66634",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92578 5.30542C4.92578 3.75064 6.18618 2.49023 7.74097 2.49023",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.bdcb43fa09b219897489718aad9abcb9.svg";
export { ForwardRef as ReactComponent };